import React, { useState, useEffect } from "react";
import Parse from "parse";
import moment from "moment-with-locales-es6";
import { Bar, Doughnut } from "react-chartjs-2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../StylesPages/slick.css";
import "../../StylesPages/dashboard.css";
import { useNavigate } from "react-router-dom";
import { Box, Text } from "@chakra-ui/react";
import {
  Chart as ChartJS,
  BarElement,
  LinearScale,
  CategoryScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Pagination } from "swiper";

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";

import "./styles.css";

ChartJS.register(BarElement, LinearScale, CategoryScale);

const MatchedUsers = () => {
  ////////////////////////////////////////////////////////////////

  moment.locale("fr");

  const navigate = useNavigate();
  const [eventsSlider, setEventsSlider] = useState([]);

  const [labelsMatch, setLabelsMatch] = useState([]);
  const [labelsYearsMatch, setLabelsYearsMatch] = useState([]);
  const [dataMatch, setDataMatch] = useState([]);

  async function fetchEvent() {
    const currentUser = Parse.User.current();

    const Match = Parse.Object.extend("Match");
    const query1 = new Parse.Query(Match);
    query1.equalTo("user1", currentUser);
    query1.greaterThanOrEqualTo(
      "createdAt",
      moment().locale("fr").subtract(180, "days").startOf("month").toDate()
    );
    query1.ascending("createdAt");

    const query2 = new Parse.Query(Match);
    query2.equalTo("user2", currentUser);
    query2.greaterThanOrEqualTo(
      "createdAt",
      moment().locale("fr").subtract(180, "days").startOf("month").toDate()
    );
    query2.ascending("createdAt");

    const mainQuery = Parse.Query.or(query1, query2);
    const match = await mainQuery.find().catch((error) => {
      alert(
        "Failed to update user informations, with error code: " + error.message
      );
      Parse.User.logOut();
      navigate("/");
    });

    const tempData = [];
    if (match !== undefined) {
      for (let i = 0; i < match.length; i++) {
        tempData.push({
          id: match[i].id,
          city: match[i].get("city"),
          date: match[i].get("createdAt").toString(),
          postalCode: match[i].get("postalCode"),
          secteur: match[i].get("secteur"),
        });
      }

      var eventsParMois = new Map();
      tempData.map((e) => {
        var month = moment(e.date);
        var monthNumber = month.month();
        var eventsOfMonthTable = eventsParMois.get(monthNumber);
        if (!eventsOfMonthTable) {
          eventsOfMonthTable = [];
        }
        eventsOfMonthTable.push(e);
        eventsParMois.set(monthNumber, eventsOfMonthTable);
      });

      setEventsSlider(eventsParMois);

      setRawData(eventsParMois);

      moment.locale("fr");

      const labels = [];
      const labelsYears = [];
      const data = [];

      var matchParMois = new Map();
      eventsParMois.forEach((value, key) => {
        labels.push(moment.months(key));
        data.push(value.length);
        var currMonth = moment.months(key);
        var date = moment(value[0].date);
        labelsYears.push(date.year());
        var matchsOfMonthTable = matchParMois.get(currMonth);

        if (!matchsOfMonthTable) {
          matchsOfMonthTable = new Map();
        }

        value.forEach((element) => {
          var x = matchsOfMonthTable.get(element.city);
          if (!x) {
            x = 0;
          }
          x++;
          matchsOfMonthTable.set(element.city, x);
        });

        matchParMois.set(currMonth, matchsOfMonthTable);
        //matchsOfMonthTable.push();
      });

      setMatchsPM(matchParMois);

      setLabelsMatch(labels);
      setLabelsYearsMatch(labelsYears);
      setDataMatch(data);

      const temp = [];
      temp.push(labels);
      temp.push(data);
      setMatchs(temp);
    }
    return match;
  }

  useEffect(() => {
    fetchEvent();
  }, []);

  ////////////////////////////////////////////////////////////////

  const [matchs, setMatchs] = useState([]);
  const [slider, setSlider] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [matchsPM, setMatchsPM] = useState([]);

  function next() {
    slider.slickNext();
  }
  function previous() {
    slider.slickPrev();
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "black" }}
        onClick={onClick}
      />
    );
  }

  var options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel;
        },
      },
    },
    responsive: true,

    scales: {
      y: {
        beginAtZero: true,
        stacked: true,
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
          mirror: false,
          stepSize: 1,
        },
      },
      x: {
        beginAtZero: true,
        stacked: true,
        grid: { drawBorder: false, display: false },
      },
    },
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    draggable: false,
    slidesToScroll: 1,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />
  };

  return (
    <Box w={"100%"}>
      <Swiper
        effect={"cards"}
        grabCursor={false}
        modules={[EffectCards]}
        className="mySwiper"
      >
        {labelsMatch.map(function (value, key) {
          return (
            <SwiperSlide key={key}>
              <Box w={"100%"} h={"100%"}>
                <Text
                  fontFamily={"Sofia Pro"}
                  fontSize={"lg"}
                  color="black"
                  align={"left"}
                  ms="20px"
                  mt="5px"
                >
                  {moment().month(value).format("MM")} / {labelsYearsMatch[key]}
                </Text>
                <Box
                  bg={"white"}
                  padding={"20px"}
                  h={"min-content"}
                  w="90%"
                  height="80%"
                  borderRadius={"20px"}
                >
                  <Bar
                    data={{
                      labels: Array.from(matchsPM.get(value).keys()),
                      datasets: [
                        {
                          label: "personnes",
                          data: Array.from(matchsPM.get(value).values()),
                          backgroundColor: [
                            "#F1404B",
                            "#0080FF",
                            "#72B2F2",
                            "#ACCCEC",
                            "##C3D6E9",
                            "rgba(255, 159, 64, 1)",
                          ],
                          borderColor: [
                            "#F1404B",
                            "#0080FF",
                            "#72B2F2",
                            "#ACCCEC",
                            "##C3D6E9",
                            "rgba(255, 159, 64, 1)",
                          ],
                          borderWidth: 5,
                          borderRadius: 80,
                          barThickness: 40,
                          grouped: true,
                        },
                      ],
                    }}
                    options={options}
                    height={"300px"}
                  />
                </Box>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {/* <div style={{ textAlign: "center" }}>
  <button onClick={previous}>
    Previous
  </button>
  <button onClick={next}>
    Next
  </button>
</div> */}
    </Box>
  );
};

export default MatchedUsers;
